module.exports = __webpack_public_path__ + "static/img/map-plot.c37730be.png";